import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { where } from '@angular/fire/firestore';
import { map, switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Signature } from '../models/signatue.model';
import { Timesheet } from '../models/timesheet.model';
import { FirestoreService } from './firestore.service';

const itemCollection = 'signatures';
const url = `${environment.backendUrl}/signature`;
const ipUrl = 'https://ipv4.myexternalip.com/json';

const setDates = (ts: Timesheet): Timesheet => {
  if (ts) {
    ts.dateIn = ts.dateIn ? new Date(ts.dateIn._seconds * 1000) : undefined;
    ts.dateOut = ts.dateOut
      ? new Date(ts.dateOut._seconds * 1000)
      : null;
    if (ts.userDates) {
      ts.userDates.in = ts.userDates.in ? new Date(ts.userDates.in._seconds * 1000) : undefined;
      ts.userDates.out = ts.userDates.out
        ? new Date(ts.userDates.out._seconds * 1000)
        : null;
    }
  }
  return ts;
};

@Injectable()
export class SignatureService {
  private firestore = inject(FirestoreService);
  private http = inject(HttpClient);

  getIp() {
    return this.http.get(ipUrl).pipe(
      map((ret) => ret['ip'] as string),
    );
  }

  passcode(item: string, passcode: string) {
    if (environment.backendUrl) {
      return this.http.post(`${url}/passcode`, { item, passcode }).pipe(
        map((ret) => ret as { status: 'invalid' | 'ok' | 'expired' | 'signed'; type: 'offer' | 'timesheet'; url?: string; item?: string; items?: Timesheet[] }),
        map((ret) => {
          if (ret.items) {
            ret.items.map((it) => setDates(it));
          }
          return ret;
        }),
      );
    }
  }

  sign(guid: string, item: string) {
    if (environment.backendUrl) {
      return this.getIp().pipe(
        switchMap((ip) => this.http.post(`${url}/sign`, { guid, item, ip }).pipe(
          map((ret) => ret as { ipAddress: string; email: string })
        )),
      );
    }
  }

  decline(guid: string, item: string) {
    if (environment.backendUrl) {
      return this.getIp().pipe(
        switchMap((ip) => this.http.post(`${url}/decline`, { guid, item, ip }).pipe(
          map((ret) => ret as { ipAddress: string; email: string })
        )),
      );
    }
  }

  get(guid: string) {
    return this.firestore.get<Signature>(itemCollection, guid);
  }

  getByItem(item: string, user?: string) {
    const queryConstraints = [where('item', '==', item)];
    if (user) {
      queryConstraints.push(where('creator.guid', '==', user));
    }
    return this.firestore.getList<Signature>(itemCollection, undefined, queryConstraints).pipe(
      map((items) => items.length > 0 ? items[0] : null),
    );
  }
}
